export const ENGAGEMENT_AUTH_ERROR_MESSAGE =
  "A non-logged-in user cannot submit engagement ratings or favorites.";

export function isEngagementAuthError(error) {
  const message = String(error?.message || "").trim().toLowerCase();
  return message.includes(ENGAGEMENT_AUTH_ERROR_MESSAGE.toLowerCase());
}

